import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  Skeleton,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Layout from "../../../components/student/Layout/layout";
import { getSectionRequest } from "../../../modules/students-modules/sections/Actions";
import defaultLogo from "../../../assets/logo.png";

const C = {
  primary: "#E85D04",
  border: "#E8E0D5",
  paper: "#FFFFFF",
  mutedBg: "#F5F0E8",
  muted: "#78716C",
};

const BASE_URL = "https://asquera.com/asquera";

function chapterLogoUrl(logo) {
  if (!logo || logo === "null" || logo === "NULL" || logo === "undefined") {
    return defaultLogo;
  }
  if (String(logo).startsWith("http")) return logo;
  return `${BASE_URL}/${String(logo).replace(/^\//, "")}`;
}

const ChaptersExamsList = ({ t }) => {
  const [searchParams] = useSearchParams();
  const section_name = searchParams.get("name");
  const navigate = useNavigate();
  const { id } = useParams();
  const section = useSelector((state) => state.sections.section);
  const isLoading = useSelector((state) => state.sections.isLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) dispatch(getSectionRequest(id));
  }, [id, dispatch]);

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="stretch">
          <Box w="100%" maxW="4xl" mx="auto">
            <Flex mb={4}>
              <Text
                as={Link}
                to="/exams/sections"
                fontSize="sm"
                fontWeight="700"
                color={C.muted}
                _hover={{ color: C.primary }}
              >
                ← Back to sections
              </Text>
            </Flex>

            <Flex
              align="center"
              justify="space-between"
              borderBottomWidth="2px"
              borderColor={C.primary}
              pb={4}
              mb={8}
              flexWrap="wrap"
              gap={4}
            >
              <Heading
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="800"
                color={C.primary}
                textTransform="uppercase"
                letterSpacing="tight"
              >
                {section_name || t("exams") || "Exams"}
              </Heading>
            </Flex>

            {isLoading && (!section || section.length === 0) ? (
              <VStack spacing={4} align="stretch">
                {[1, 2, 3].map((k) => (
                  <Skeleton key={k} h="72px" borderRadius="xl" />
                ))}
              </VStack>
            ) : !section?.length ? (
              <Text color={C.muted} fontWeight="600">
                No chapters available for this section yet.
              </Text>
            ) : (
              <VStack spacing={4} align="stretch">
                {section.map((chapter) => (
                  <Flex
                    key={chapter?.id}
                    bg={C.paper}
                    borderWidth="1px"
                    borderColor={C.border}
                    borderRadius="xl"
                    px={6}
                    py={5}
                    align="center"
                    gap={4}
                    cursor="pointer"
                    transition="border-color 0.2s, background 0.2s"
                    _hover={{ bg: C.mutedBg, borderColor: C.primary }}
                    onClick={() =>
                      navigate(
                        `/exam/${chapter?.id}?name=${encodeURIComponent(
                          chapter?.name || ""
                        )}`
                      )
                    }
                  >
                    <Avatar
                      name={chapter?.name}
                      src={chapterLogoUrl(chapter?.logo)}
                      borderRadius="lg"
                      size="md"
                      bg="transparent"
                      flexShrink={0}
                    />
                    <Text flex={1} fontWeight="700" fontSize="md" color={C.primary}>
                      {chapter?.name}
                    </Text>
                  </Flex>
                ))}
              </VStack>
            )}
          </Box>
        </VStack>
      </Container>
    </Layout>
  );
};

export default withTranslation()(ChaptersExamsList);
